@switch (headingTag) {
    @case (1) {
        <h1
            [class]="textClass()"
            [attr.itemprop]="itemprop()"
        >
            {{ text() }}
        </h1>
    }
    @case (2) {
        <h2
            [class]="textClass()"
            [attr.itemprop]="itemprop()"
        >
            {{ text() }}
        </h2>
    }
    @case (3) {
        <h3
            [class]="textClass()"
            [attr.itemprop]="itemprop()"
        >
            {{ text() }}
        </h3>
    }
    @case (4) {
        <h4
            [class]="textClass()"
            [attr.itemprop]="itemprop()"
        >
            {{ text() }}
        </h4>
    }
    @case (5) {
        <h5
            [class]="textClass()"
            [attr.itemprop]="itemprop()"
        >
            {{ text() }}
        </h5>
    }
    @case (6) {
        <h6
            [class]="textClass()"
            [attr.itemprop]="itemprop()"
        >
            {{ text() }}
        </h6>
    }
}
